// Mock data for rental property website - Bilingual content

export const propertyImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1775053383038-5e248d3182a7",
    alt: "Property exterior"
  },
  {
    id: 2,
    url: "https://images.pexels.com/photos/36676787/pexels-photo-36676787.jpeg",
    alt: "Bedroom"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1638885930125-85350348d266",
    alt: "Living room"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1766603636766-1f4662469448",
    alt: "Outdoor area"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1761158499630-b895072679cd",
    alt: "Coastal view"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1566073771259-6a8506099945",
    alt: "Dining area"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf",
    alt: "Kitchen"
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1560185127-6d2e3f9b8e3f",
    alt: "Bathroom"
  }
];

// Mock blocked dates (simulating ICS feed data from Airbnb, Booking.com, etc.)
// In production, these would be parsed from actual ICS feeds
export const blockedDates = [
  // December 2024
  "2024-12-15",
  "2024-12-16",
  "2024-12-17",
  "2024-12-18",
  "2024-12-19",
  "2024-12-20",
  "2024-12-24",
  "2024-12-25",
  "2024-12-26",
  "2024-12-31",
  // January 2025
  "2025-01-01",
  "2025-01-02",
  "2025-01-03",
  "2025-01-10",
  "2025-01-11",
  "2025-01-12",
  "2025-01-13",
  "2025-01-14",
  // February 2025
  "2025-02-14",
  "2025-02-15",
  "2025-02-16",
];

export const content = {
  es: {
    // Header
    languageLabel: "Idioma",
    
    // Hero
    showAllPhotos: "Mostrar todas las fotos",
    
    // Property Title
    propertyName: "Villa Paraíso Costero",
    propertyLocation: "Playa del Carmen, Quintana Roo, México",
    propertyStats: "4 viajeros · 2 dormitorios · 3 camas · 1 baño",
    
    // Calendar
    availabilityTitle: "Disponibilidad",
    availableDates: "Disponible",
    bookedDates: "Reservado",
    calendarSync: "Sincronizado con Airbnb, Booking.com y otros calendarios",
    
    // Description Section
    descriptionTitle: "Descripción de la propiedad",
    description: `Bienvenido a Villa Paraíso Costero, tu refugio perfecto frente al mar. Esta impresionante propiedad combina el lujo moderno con el encanto costero, ofreciendo una experiencia de vacaciones inolvidable.

Con capacidad para 8 huéspedes, nuestra villa cuenta con 4 dormitorios espaciosos, 3 baños completos, una cocina totalmente equipada y amplias áreas de estar. Disfruta de impresionantes vistas al océano desde la terraza privada, relájate junto a la piscina infinity o simplemente descansa en nuestros cómodos espacios interiores con aire acondicionado.

La propiedad está diseñada para proporcionar tanto privacidad como oportunidades de reunión, con múltiples espacios de entretenimiento en interiores y exteriores. Acceso directo a la playa, WiFi de alta velocidad y todas las comodidades modernas que necesitas para una estancia perfecta.`,
    
    propertyFeatures: "Características principales",
    features: [
      "4 dormitorios • 3 baños",
      "Capacidad para 8 huéspedes",
      "Piscina privada infinity",
      "Acceso directo a la playa",
      "WiFi de alta velocidad",
      "Cocina totalmente equipada",
      "Aire acondicionado en todas las habitaciones",
      "Terraza con vista al mar"
    ],
    
    // Location Section
    locationTitle: "Ubicación",
    locationDescription: "Ubicada en la hermosa Playa del Carmen, nuestra villa ofrece el equilibrio perfecto entre tranquilidad y conveniencia. Estás a solo minutos de restaurantes de clase mundial, tiendas boutique y las famosas atracciones de la Riviera Maya.",
    locationDetails: [
      "5 minutos a pie de la playa principal",
      "10 minutos en auto al centro de Playa del Carmen",
      "15 minutos al parque Xcaret",
      "45 minutos del aeropuerto internacional de Cancún"
    ],
    
    // House Rules Section
    rulesTitle: "Reglas de la casa",
    rules: [
      "Check-in: 3:00 PM",
      "Check-out: 11:00 AM",
      "No se permiten mascotas",
      "No fumar en el interior",
      "No fiestas o eventos",
      "Número máximo de huéspedes: 8",
      "Respeta a los vecinos y mantén un nivel de ruido razonable después de las 10:00 PM",
      "Por favor, cuida la propiedad como si fuera tuya"
    ],
    
    // Cancellation Policy Section
    cancellationTitle: "Política de cancelación",
    cancellationPolicy: `Cancelación flexible con las siguientes condiciones:

• Cancelación gratuita hasta 30 días antes del check-in
• 50% de reembolso para cancelaciones entre 30 y 14 días antes del check-in
• Sin reembolso para cancelaciones dentro de los 14 días previos al check-in

En caso de circunstancias extraordinarias, se evaluarán excepciones caso por caso. Se requiere un depósito del 30% al momento de la reserva, con el saldo restante debido 14 días antes del check-in.`,
    
    // Sidebar - Pricing
    pricingTitle: "Precios por temporada",
    seasonalPrices: [
      { season: "Temporada Baja", dates: "Mayo - Octubre", price: "$250", unit: "/noche" },
      { season: "Temporada Media", dates: "Noviembre - Marzo", price: "$350", unit: "/noche" },
      { season: "Temporada Alta", dates: "Diciembre 20 - Enero 10", price: "$500", unit: "/noche" }
    ],
    minStay: "Estancia mínima: 3 noches",
    weeklyDiscount: "Descuento semanal: 10%",
    
    // Sidebar - Contact Form
    contactFormTitle: "Solicitar información",
    namePlaceholder: "Tu nombre",
    emailPlaceholder: "Tu correo electrónico",
    phonePlaceholder: "Tu teléfono (opcional)",
    messagePlaceholder: "Cuéntanos sobre tus planes de viaje...",
    checkInLabel: "Fecha de entrada",
    checkOutLabel: "Fecha de salida",
    guestsLabel: "Número de huéspedes",
    sendButton: "Enviar consulta",
    
    // WhatsApp Widget
    whatsappButton: "Contactar por WhatsApp",
    whatsappText: "¡Hola! Me interesa Villa Paraíso Costero",
    
    // Success messages
    formSuccess: "¡Gracias! Hemos recibido tu consulta y te contactaremos pronto.",
    
    // Footer
    footerText: "© 2024 Villa Paraíso Costero. Todos los derechos reservados.",
    footerLinks: ["Privacidad", "Términos", "Contacto"]
  },
  
  en: {
    // Header
    languageLabel: "Language",
    
    // Hero
    showAllPhotos: "Show all photos",
    
    // Property Title
    propertyName: "Coastal Paradise Villa",
    propertyLocation: "Playa del Carmen, Quintana Roo, Mexico",
    propertyStats: "4 guests · 2 bedrooms · 3 beds · 1 bathroom",
    
    // Calendar
    availabilityTitle: "Availability",
    availableDates: "Available",
    bookedDates: "Booked",
    calendarSync: "Synced with Airbnb, Booking.com and other calendars",
    
    // Description Section
    descriptionTitle: "Property description",
    description: `Welcome to Coastal Paradise Villa, your perfect beachfront retreat. This stunning property combines modern luxury with coastal charm, offering an unforgettable vacation experience.

Accommodating up to 8 guests, our villa features 4 spacious bedrooms, 3 full bathrooms, a fully-equipped kitchen, and expansive living areas. Enjoy breathtaking ocean views from the private terrace, relax by the infinity pool, or simply unwind in our comfortable air-conditioned indoor spaces.

The property is designed to provide both privacy and gathering opportunities, with multiple indoor and outdoor entertainment spaces. Direct beach access, high-speed WiFi, and all the modern amenities you need for a perfect stay.`,
    
    propertyFeatures: "Key features",
    features: [
      "4 bedrooms • 3 bathrooms",
      "Sleeps 8 guests",
      "Private infinity pool",
      "Direct beach access",
      "High-speed WiFi",
      "Fully equipped kitchen",
      "Air conditioning throughout",
      "Ocean-view terrace"
    ],
    
    // Location Section
    locationTitle: "Location",
    locationDescription: "Located in beautiful Playa del Carmen, our villa offers the perfect balance of tranquility and convenience. You're just minutes from world-class restaurants, boutique shopping, and the famous attractions of the Riviera Maya.",
    locationDetails: [
      "5-minute walk to main beach",
      "10-minute drive to Playa del Carmen downtown",
      "15 minutes to Xcaret Park",
      "45 minutes from Cancun International Airport"
    ],
    
    // House Rules Section
    rulesTitle: "House rules",
    rules: [
      "Check-in: 3:00 PM",
      "Check-out: 11:00 AM",
      "No pets allowed",
      "No smoking indoors",
      "No parties or events",
      "Maximum number of guests: 8",
      "Respect neighbors and keep noise level reasonable after 10:00 PM",
      "Please treat the property as your own"
    ],
    
    // Cancellation Policy Section
    cancellationTitle: "Cancellation policy",
    cancellationPolicy: `Flexible cancellation with the following terms:

• Free cancellation up to 30 days before check-in
• 50% refund for cancellations between 30 and 14 days before check-in
• No refund for cancellations within 14 days of check-in

In case of extraordinary circumstances, exceptions will be evaluated on a case-by-case basis. A 30% deposit is required at booking, with the remaining balance due 14 days before check-in.`,
    
    // Sidebar - Pricing
    pricingTitle: "Seasonal pricing",
    seasonalPrices: [
      { season: "Low Season", dates: "May - October", price: "$250", unit: "/night" },
      { season: "Mid Season", dates: "November - March", price: "$350", unit: "/night" },
      { season: "High Season", dates: "Dec 20 - Jan 10", price: "$500", unit: "/night" }
    ],
    minStay: "Minimum stay: 3 nights",
    weeklyDiscount: "Weekly discount: 10%",
    
    // Sidebar - Contact Form
    contactFormTitle: "Request information",
    namePlaceholder: "Your name",
    emailPlaceholder: "Your email",
    phonePlaceholder: "Your phone (optional)",
    messagePlaceholder: "Tell us about your travel plans...",
    checkInLabel: "Check-in date",
    checkOutLabel: "Check-out date",
    guestsLabel: "Number of guests",
    sendButton: "Send inquiry",
    
    // WhatsApp Widget
    whatsappButton: "Contact via WhatsApp",
    whatsappText: "Hi! I'm interested in Coastal Paradise Villa",
    
    // Success messages
    formSuccess: "Thank you! We've received your inquiry and will contact you soon.",
    
    // Footer
    footerText: "© 2024 Coastal Paradise Villa. All rights reserved.",
    footerLinks: ["Privacy", "Terms", "Contact"]
  }
};

// Mock WhatsApp number
export const whatsappNumber = "+521234567890";
